import * as React from 'react';
import { currentDocument } from '../utils/env';

export function useHasChildNodes(element: HTMLElement) {
    const [hasChildren, setHasChildren] = React.useState(element === currentDocument.body);
    const observer = React.useMemo(() => new MutationObserver((records) => {
        setHasChildren(records[0]?.target.hasChildNodes());
    }), []);
    React.useEffect(() => {

        const isObserving = element !== currentDocument.body;
        if (isObserving) {
            setHasChildren(element.childNodes.length > 0);
            observer.observe(element, { childList: true });
        }

        return () => {
            if (isObserving) { observer.disconnect(); }
        };

    }, [element, observer]);

    return hasChildren;
}
